import { BuyerDetailAfterMatch as BuyerDetailAfterMatchPage } from 'ui/components/agent/patterns/BuyerDetailAfterMatch/BuyerDetailAfterMatch';

/**
 * 買い手企業詳細（マッチング後のため詳細情報を取得可能）
 */
export const BuyerDetailAfterMatch: React.FC = () => {
    return <BuyerDetailAfterMatchPage />;
};
